export class JobsDTO {
  isFuzzySearch: boolean;
  isWildCardSearch: boolean;
  searchResults: {
    bins: BinsDTO[];
  };
  suggestionResultSection: any[];
  facets: FacetContainer[];
  startRow: number;
  totalCount: number;
  pageCount: number;
  skillSoftResults: any;
  actionResponse: {
    isValid: boolean,
    actionResponseType: number,
    targetEntityId: number,
    reason: String,
    nlActionKey: String,
    searchText: String
  };
  facetFields: any;
  errorTypeId: 0;
}

export class FacetContainer {
  facetName: String;
  fieldName: String;
  facetType: String;
  facetItems: Facet[];
  isFacetShowMore: Boolean;
  showLess: Boolean;
  facetLimit: number;
}

export class Facet {
  name: String;
  value: String;
  isApplied: boolean;
  filterQuery: {
    name: String,
    searchFieldName: String,
    value: String
  };
  isHidden: Boolean;
}

export class BinResult {
  $type: String;
  id: number;
  score: String;
  title: String;
  description: String;
  category: String;
  percentageMatch: number;
  ext_PostingDate: String;
  hiringSupervisor: String;
  recruiter: String;
  departmentName: String;
  geographicDistance: number;
  requisitionCode: String;
  city: String;
  state: String;
  country: String;
  address: String;
  postalCode: String;
  distance: number;
  isFavorite: boolean;
  isApplied: boolean;
  status: string;
  travelTime: string;
  videoURL: string;
};

export class BinsDTO {
  binName: String;
  binKey: String;
  binCount: number;
  resultItems: {
    searchResults: BinResult[],
    totalCount: number,
    pageCount: number
  };
}

export class Jobsfilter {
  name: String;
  searchFieldName: String;
  uncodedValue: String;
  value: String;
}

export class SavedSearchFilter {
  id: number;
  name: String;
  personFK: number;
  searchText: String;
  startRow: number;
  pgCount: any;
  contexts: String;
  filters: any;
}

export class SavedSearch {
  searchText: String;
  startRow: number;
  pageCount: number;
  sortBy: String;
  sortOrder: string;
  contexts: String[];
  filters: Jobsfilter[];
  facetsRequired: boolean;
  sortFilters: any[];
  requestType: number;
  requestForNLActions: boolean;
  facetType: any;
  facetSearchString: String;
  facetLimit: number;
}

class SortFilters {
  SortField: String;
  SortDirection: String;
}

export class FilterData {
  SearchText: String;
  StartRow: Number;
  PageCount: number;
  Contexts: String[];
  Filters: Jobsfilter[];
  SortFilters: SortFilters[];
  FacetLimit?: Number;
  KeywordSearchText: String;
}
export class MultiSelect {
  Id: String;
  name: String;
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/job-search/job-results.dto.ts